export default "/images/47353c0248f43eb2c4d39160cfeb1458.avif";